module.exports = __webpack_public_path__ + "img/chilun_img2.62ec0167.png";